export default __webpack_public_path__ + "static/media/Sefcon-DS-100-ml-ban.bb0d6c2b.jpg";